import React from 'react';
import { Link } from '@mui/material';

import { RedMessageBar } from 'components/RedMessageBar';

export const isPlaceSearchError = (error) => !!error?.response?.data?.code?.startsWith('places_');

export const PlaceSearchUnavailableNotice = ({ message, clearLabel, onClear }) => (
  <RedMessageBar
    sx={{ my: 2, cursor: 'default' }}
    message={
      <>
        {message}{' '}
        <Link component="button" type="button" onClick={onClear} color="inherit" sx={{ fontWeight: 600, verticalAlign: 'baseline' }}>
          {clearLabel}
        </Link>
      </>
    }
  />
);
